"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyShapeWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LobbyShapeWindowModule = _interopRequireDefault(require("./LobbyShapeWindow.module.scss"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getNextValOf(value) {
  // TODO
  // var types = new Array('A','B','C','D','E','F');
  switch (value) {
    case "A":
      return "B";

    case "B":
      return "C";

    case "C":
      return "D";

    default:
      throw new Error("Unknown shape value '".concat(value, "'."));
  }
}

function LobbyShapeWindow(_ref) {
  var onChangeShape = _ref.onChangeShape,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)("A"),
      _useState2 = _slicedToArray(_useState, 2),
      face = _useState2[0],
      setFace = _useState2[1];

  var _useState3 = (0, _react.useState)("A"),
      _useState4 = _slicedToArray(_useState3, 2),
      hair = _useState4[0],
      setHair = _useState4[1];

  var _useState5 = (0, _react.useState)("A"),
      _useState6 = _slicedToArray(_useState5, 2),
      size = _useState6[0],
      setSize = _useState6[1];

  var decrease = (0, _react.useCallback)(function (entry) {
    switch (entry) {
      case "FACE":
        setFace("A");
        break;

      case "HAIR":
        setHair("A");
        break;

      case "SIZE":
        setSize("A");
        break;

      default:
        throw new Error("unknown shape entry '".concat(JSON.stringify(entry), "'."));
    }

    if (onChangeShape) onChangeShape({
      face: face,
      hair: hair,
      size: size
    });
  }, [face, hair, onChangeShape, size]);
  var increase = (0, _react.useCallback)(function (entry) {
    switch (entry) {
      case "FACE":
        setFace("A");
        break;

      case "HAIR":
        setHair("A");
        break;

      case "SIZE":
        setSize("A");
        break;

      default:
        throw new Error("unknown shape entry '".concat(JSON.stringify(entry), "'."));
    }

    if (onChangeShape) onChangeShape({
      face: face,
      hair: hair,
      size: size
    });
  }, [face, hair, onChangeShape, size]);
  var renderEntry = (0, _react.useCallback)(function (entry, value) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _LobbyShapeWindowModule.default[entry]
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _LobbyShapeWindowModule.default.decrease,
      type: _EButtonType.default.LEFT,
      onClick: function onClick() {
        decrease(entry);
      }
    }, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
      className: _LobbyShapeWindowModule.default.value
    }, value), /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _LobbyShapeWindowModule.default.increase,
      type: _EButtonType.default.RIGHT,
      onClick: function onClick() {
        increase(entry);
      }
    }, "\xA0"));
  }, [decrease, increase]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LobbyShapeWindowModule.default.window, className),
    style: style
  }, renderEntry("FACE", face), renderEntry("HAIR", hair), renderEntry("SIZE", size));
}